import {Dropdown, Button} from "antd";
import {GlobalOutlined, CheckOutlined} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { changeLanguage } from "../../../i18n";

export default function LanguageMenu({size = "small", theme = "white"}) {
    const {i18n, t} = useTranslation("common");
    const current = i18n.language?.startsWith("fr") ? "fr" : "en";

    const handleLanguageChange = async (newLang) => {
        await changeLanguage(newLang);
    };

    // Styles selon le thème
    const getButtonStyle = () => {
        const baseStyle = {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            borderRadius: "6px",
            padding: "4px 8px",
            height: "auto",
            transition: "all 0.2s ease"
        };

        if (theme === "blue") {
            return {
                ...baseStyle,
                color: "var(--color-primary)",
                backgroundColor: "rgba(24, 144, 255, 0.1)",
                border: "1px solid var(--color-primary)",
            };
        }

        // theme === "white" (défaut)
        return {
            ...baseStyle,
            color: "white",
            border: "1px solid rgba(255,255,255,0.2)",
            backgroundColor: "rgba(255,255,255,0.1)",
        };
    };

    const getIconColor = () => {
        return theme === "blue" ? "var(--color-primary)" : "white";
    };

    const getTextColor = () => {
        return theme === "blue" ? "var(--color-primary)" : "white";
    };

    const items = [
        {
            key: "fr",
            label: (
                <div
                    style={{display: "flex", justifyContent: "space-between", alignItems: "center", minWidth: "100px"}}>
                    <span>{t("language.fr", { defaultValue: "🇫🇷 Français" })}</span>
                    {current === "fr" ? <CheckOutlined style={{color: "#52c41a"}}/> : null}
                </div>
            ),
            onClick: () => handleLanguageChange("fr"),
        },
        {
            key: "en",
            label: (
                <div
                    style={{display: "flex", justifyContent: "space-between", alignItems: "center", minWidth: "100px"}}>
                    <span>{t("language.en", { defaultValue: "🇺🇸 English" })}</span>
                    {current === "en" ? <CheckOutlined style={{color: "#52c41a"}}/> : null}
                </div>
            ),
            onClick: () => handleLanguageChange("en"),
        },
    ];

    return (
        <Dropdown
            menu={{items}}
            trigger={["click"]}
            placement="bottomRight"
            overlayStyle={{minWidth: "120px"}}
        >
            <Button
                size={size}
                type="text"
                aria-label={t("language.change", { defaultValue: "Change language" })}
                style={getButtonStyle()}
                className={`language-menu-${theme}`}
            >
                <GlobalOutlined style={{color: getIconColor()}}/>
                <span className="language-menu-label" style={{
                    textTransform: "uppercase",
                    fontSize: "12px",
                    fontWeight: "500",
                    color: getTextColor()
                }}>
                    {current}
                </span>
            </Button>
        </Dropdown>
    );
}
